
  import { mapState } from 'vuex'
  export default {
    data() {
      return {
        paymentType: 'bank',
        forceToAddBankAccountModal: false,
        forceToAddWalletAddressModal: false,
        disabledToWithdrawal: false,
        existLoading: false,
        steppers: null,
        resultData: {}
      }
    },
    computed: {
      ...mapState({
        player: state => state.player.player,
        depositFlow: state => state.themes.deposit.depositFlow,
        operationSetting: state => state.settings.operationSetting,
        playerCryptoWallets: state => state.themes['player-bank'].playerCryptoWallets
      })
    },
    watch: {
      player(value) {
        this.checkIfWithdrawalExist()
        // this.checkWebsiteSettings()
      },
      depositFlow(value) {
        // RegFlow = 5 is crypto currency
        if (~~value?.reg_flow === 5) {
          this.paymentType = 'crypto'
        }
      },
      operationSetting(value) {
        // only international
        if (~~value?.reg_flow !== 5) {
          const hasBankAccount = this.player.has_bank_account
          if (hasBankAccount === false) {
            this.forceToAddBankAccountModal = true
            this.disabledToWithdrawal = true
          }
        }
      },
      playerCryptoWallets(value) {
        if (value.length === 0) {
          if (this.operationSetting.reg_flow === 5) {
            this.forceToAddWalletAddressModal = true
          }
        }
      }
    },
    async mounted() {
      await this.checkIfWithdrawalExist()
      // this.checkWebsiteSettings()
      // execute only inter wl
      // if (this.isInternational) {
      this.$store.dispatch('settings/operationSetting', this.$cookie.get('player')?.currency)
      // }
      this.$root.withdrawExistChange = item => {
        if (!item?.is_exist) {
          this.steppers = 1
          this.resultData = {}
        } else {
          this.resultData = { ...item }
          this.steppers = 2
        }
      }
    },
    destroyed() {
      this.$root.withdrawExistChange = null
    },
    methods: {
      checkWebsiteSettings() {
        // const hasBankAccount = this.player.has_bank_account
        // if (hasBankAccount === false && !this.isInternational) {
        //   this.forceToAddBankAccountModal = true
        //   this.disabledToWithdrawal = true
        // } else if (hasBankAccount === false) {
        //   this.forceToAddBankAccountModal = true
        //   this.disabledToWithdrawal = true
        // }
      },
      async checkIfWithdrawalExist() {
        if (this.player?.has_bank_account) {
          this.existLoading = true
          const result = await this.$store.dispatch('themes/withdraw/checkExistWithdrawal')
          if (result?.is_exist) {
            this.resultData = result
            if (result.payment_provider_code === 'crypto') {
              this.paymentType = 'crypto'
            }
            this.steppers = 2
          }
          this.existLoading = false
        }
      }
    }
  }
